@if ((remainingRequiredEndorsementTotal$ | async) > 0) {
  <span
    data-testid="req-endorsement-actions-remaining"
    >Actions Remaining in this Document: {{ remainingRequiredEndorsementTotal$ | async }}/{{ requiredEndorsementTotal$ | async }}</span
    >
  }

  @if ((remainingRequiredEndorsementTotal$ | async) === 0) {
    <span
      data-testid="req-endorsement-complete"
      >
      Document Complete
    </span>
  }
